var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCamIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 26.5714,
    height: 26.7914,
    rx: 13.2857,
    fill: "#123164",
    stroke: "white",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.859 10.7938C17.4959 10.7938 17.1626 10.5839 16.9959 10.26L16.5673 9.39023C16.2935 8.8444 15.5792 8.39453 14.9721 8.39453H13.609C12.9959 8.39453 12.2816 8.8444 12.0078 9.39023L11.5792 10.26C11.4126 10.5839 11.0792 10.7938 10.7161 10.7938C9.42447 10.7938 8.40066 11.8915 8.484 13.1871L8.79352 18.1416C8.86495 19.3772 9.52567 20.3909 11.1685 20.3909H17.4066C19.0495 20.3909 19.7042 19.3772 19.7816 18.1416L20.0911 13.1871C20.1745 11.8915 19.1507 10.7938 17.859 10.7938ZM13.3947 11.5436H15.1804C15.4245 11.5436 15.6269 11.7475 15.6269 11.9935C15.6269 12.2394 15.4245 12.4433 15.1804 12.4433H13.3947C13.1507 12.4433 12.9483 12.2394 12.9483 11.9935C12.9483 11.7475 13.1507 11.5436 13.3947 11.5436ZM14.2876 18.0636C13.1804 18.0636 12.2757 17.1579 12.2757 16.0362C12.2757 14.9146 13.1745 14.0088 14.2876 14.0088C15.4007 14.0088 16.2995 14.9146 16.2995 16.0362C16.2995 17.1579 15.3947 18.0636 14.2876 18.0636Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamIcon);
export default __webpack_public_path__ + "static/media/camIcon.d1e0844eaefa17fb18c722b1f5077c7c.svg";
export { ForwardRef as ReactComponent };